<template>
  <div>
    <SystemAlerts :hasHeader="hasHeader" />
    <AIChatbot />
    <HintSystem />
    <HintSideBar />
    <LoggingBeacon />
  </div>
</template>

<script>
import SystemAlerts from 'component-system-alerts'
import AIChatbot from 'component-ai-chatbot'
import HintSystem from 'component-hint-system'
import HintSideBar from 'component-hint-sidebar'
import LoggingBeacon from 'component-logging-beacon'

export default {
  name: 'CompositeEssentials',
  components: {
    SystemAlerts,
    AIChatbot,
    HintSystem,
    HintSideBar,
    LoggingBeacon,
  },
  props: {
    hasHeader: {
      type: Boolean,
    },
    preventBillingAccountCall: {
      type: Boolean,
    }
  },
}
</script>

<style scoped></style>
